import { render } from "./ProcedureStageInfo.vue?vue&type=template&id=4e74ca4a&scoped=true"
import script from "./ProcedureStageInfo.vue?vue&type=script&lang=js"
export * from "./ProcedureStageInfo.vue?vue&type=script&lang=js"

import "./ProcedureStageInfo.vue?vue&type=style&index=0&id=4e74ca4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e74ca4a"]])

export default __exports__